// @flow
/**
 * @module Epics/categoria
 * @desc Categoria
 */

import { ActionTypes } from '../utils/constants';
import { ofType, ActionsObservable } from 'redux-observable';
import { switchMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

import { BaseApiService } from '../utils/BaseApiService';
import {
  fetchTestDriveInfoSuccess,
  fetchTestDriveInfoFailure,
  requestTestDriveSuccess,
  requestTestDriveFailure,
  fetchTestDriveRsvpSuccess,
  fetchTestDriveRsvpFailure
} from '../actions';

export function fetchTestDriveInfo(action$: ActionsObservable) {
  return action$.pipe(
    ofType(ActionTypes.FETCH_TEST_DRIVE_INFO_REQUEST),
    switchMap(action => {
      return BaseApiService.get(`/api/test-drive/`).pipe(
        map(({ response: { data } }) => {
          return fetchTestDriveInfoSuccess(data);
        }),
        catchError(
          /* istanbul ignore next  */ ({ actions = [] }) =>
            of(fetchTestDriveInfoFailure(), ...actions)
        )
      );
    })
  );
}

export function fetchTestDriveRsvpRequest(action$: ActionsObservable) {
  return action$.pipe(
    ofType(ActionTypes.FETCH_TEST_DRIVE_RSVP_REQUEST),
    switchMap(action => {
      return BaseApiService.get(`/api/test-drive/reserva/${action.payload.id}/`).pipe(
        map(({ response: { data } }) => {
          return fetchTestDriveRsvpSuccess(data);
        }),
        catchError(
          /* istanbul ignore next  */ ({ actions = [] }) =>
            of(fetchTestDriveRsvpFailure(), ...actions)
        )
      );
    })
  );
}

export function requestTestDrive(action$: ActionsObservable, store) {
  return action$.pipe(
    ofType(ActionTypes.REQUEST_TEST_DRIVE_REQUEST),
    switchMap(action => {
      return BaseApiService.post(`/api/test-drive/${store.value?.categoria?.queryString}`, {
        ...action.payload.testDrive,
        date_rvsp: action.payload.testDrive.date_rvsp.toString(),
        time: action.payload.testDrive.time.toString(),
      }).pipe(
        map(({ response: { data } }) => {
          return requestTestDriveSuccess(data);
        }),
        catchError(
          /* istanbul ignore next  */ ({ actions = [] }) =>
            of(requestTestDriveFailure(), ...actions)
        )
      );
    })
  );
}
